import React from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import ReplayIcon from '@mui/icons-material/Replay';

import Button from '@ui-lib/components/Button';

interface CameraErrorProps {
  errorMessage: string;
  onRetry: () => void;
}

export const CameraError = ({ errorMessage, onRetry }: CameraErrorProps) => {
  const { t } = useTranslation();

  return (
    <Stack alignItems='center' gap={1}>
      <ErrorOutlineOutlinedIcon color='error' fontSize='large' />
      <Typography variant='subtitle1Bold'>{t('error')}</Typography>
      <Typography variant='body2' color='secondary'>{errorMessage}</Typography>
      <Button
        variant='tonal'
        fullWidth
        onClick={onRetry}
        startIcon={<ReplayIcon />}
      >
        {t('bolCreatePage_retakePhoto')}
      </Button>
    </Stack>
  );
};
